<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 40px">
      <Loading></Loading>
    </div>
    <v-container
      v-else
      class="Kanit px-5"
      grid-list-xs
      style="padding-bottom: 80px; position: relative"
    >
      <transition :name="transitionname" mode="in-out">
        <div :key="1" class="transition" v-if="step == 1">
          <div style="text-align: center" class="py-2 mb-3">
            <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
          </div>
          <div class="mb-2">
            <div class="mt-2">
              <b>ลูกค้า</b>
              : {{ data2.customername }}
            </div>
            <div class="mt-2" style="font-weight: 600">ที่อยู่ในการขนส่ง</div>
            <div v-if="data2.customeraddress">
              {{ data2.customeraddress.replace(/\,\./g, " ") }}
            </div>
          </div>
          <div class="Kanit">
            <ValidationObserver ref="observer" tag="form">
              <form>
                <div>
                  <v-card
                    class="mb-2 pa-1"
                    outlined
                    v-for="item in products"
                    :key="item.id"
                  >
                    <v-row>
                      <v-col cols="5">
                        <div v-if="item.image">
                          <v-img
                            lazy-src="../assets/whiteimg.jpg"
                            :src="item.image"
                            @error="() => (item.image = null)"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                        <div v-else>
                          <div
                            style="
                              height: 100px;
                              width: 100px;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                          >
                            <v-icon>mdi-block-helper</v-icon>
                          </div>
                        </div>
                      </v-col>
                      <v-col class="pl-0" cols="7">
                        <div style="font-weight: bold; font-size: 13px">
                          {{ item.sales_text_th }}
                        </div>
                        <div style="padding-right: 13px; font-size: 11px">
                          ขนาด: {{ item.size }} สี: {{ item.shade }}
                          {{ item.film_type ? `ฟิล์ม: ` + item.film_type : "" }}
                        </div>
                        <div
                          style="
                            padding-right: 13px;
                            font-weight: bold;
                            font-size: 13px;
                          "
                        >
                          จำนวน: {{ item.quantity }}
                        </div>
                        <div style="font-size: 35px">
                          <ValidationProvider
                            :name="'ราคา' + item.id"
                            :rules="'required|min_value:1'"
                            :key="item.id"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              :error-messages="
                                errors.length ? 'กรุณากรอกราคา' : ''
                              "
                              full-width
                              class="smallpriceinput"
                              outlined
                              dense
                              min="1"
                              v-model="item.price"
                              :hide-details="errors.length ? false : true"
                              placeholder="ราคาต่อชิ้น"
                              value="10.00"
                            ></v-text-field>
                          </ValidationProvider>
                        </div>
                        <div v-if="item.price" style="color: red">
                          ราคารวม:
                          {{
                            parseFloat(item.quantity) * parseFloat(item.price)
                          }}
                        </div>
                        <div v-else style="color: red">ราคารวม: 0</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>

                <div>
                  <v-card outlined>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <div style="font-weight: bold">การจัดส่งสินค้า</div>
                          <div>
                            <ValidationProvider
                              name="การจัดส่ง"
                              :rules="'required'"
                              v-slot="{ errors }"
                            >
                              <v-radio-group
                                :error-messages="errors"
                                dense
                                v-model="radios"
                                :mandatory="false"
                              >
                                <v-row class="pl-3">
                                  <v-col class="pa-0" cols="6">
                                    <v-radio
                                      class="radiosmallfont"
                                      style="font-size: 12px"
                                      dense
                                      label="ร้านจัดส่งเอง"
                                      value="storeshipping"
                                    ></v-radio>
                                  </v-col>
                                  <v-col class="pa-0 pr-2" cols="6">
                                    <ValidationProvider
                                      name="ค่าขนส่ง"
                                      :rules="{
                                        required: radios == 'storeshipping',
                                      }"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        :error-messages="errors"
                                        placeholder="ราคาขนส่ง"
                                        :disabled="radios != 'storeshipping'"
                                        class="smallpriceinput"
                                        v-model="storeshippingprice"
                                        single-line
                                        outlined
                                        dense
                                      ></v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>

                                <v-row class="pl-3" v-if="!hasGypsum">
                                  <v-col class="pa-0" cols="6">
                                    <v-radio
                                      class="radiosmallfont"
                                      dense
                                      placeholder="scgexpress"
                                      label="ส่งผ่าน SCG"
                                      value="scgexpress"
                                    >
                                      <template slot="label">
                                        <img
                                          style="width: 98px"
                                          src="../assets/scgexpress.png"
                                        />
                                      </template>
                                    </v-radio>
                                  </v-col>
                                  <v-col class="pa-0 pr-2" cols="6">
                                    <ValidationProvider
                                      name="ค่าขนส่ง SCG Express"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        type="number"
                                        :error-messages="errors"
                                        placeholder="ค่าขนส่งเพิ่มเติม (ถ้ามี)"
                                        :disabled="radios != 'scgexpress'"
                                        class="smallpriceinput"
                                        min="0"
                                        :prefix="shippingprice + ' + '"
                                        v-model="additionalshippingprice"
                                        single-line
                                        outlined
                                        dense
                                      ></v-text-field>
                                    </ValidationProvider>
                                  </v-col>
                                </v-row>
                              </v-radio-group>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <div>
                            <div style="font-size: 13px">
                              ราคาสินค้า:
                              {{ parseFloat(sumprice).toFixed(2) }} บาท
                            </div>
                            <div style="font-size: 13px">
                              ค่าขนส่ง:
                              {{
                                parseFloat(
                                  formatedShippingprice
                                    ? formatedShippingprice
                                    : 0
                                ).toFixed(2)
                              }}
                              บาท
                            </div>
                            <div style="color: red">
                              ราคารวม:
                              {{
                                (
                                  parseFloat(
                                    formatedShippingprice
                                      ? parseFloat(formatedShippingprice)
                                      : 0
                                  ) + parseFloat(sumprice)
                                ).toFixed(2)
                              }}
                              บาท
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <div class="mt-2">
                        <v-textarea
                          placeholder="หมายเหตุ"
                          outlined
                          v-model="remark"
                          auto-grow
                        >
                        </v-textarea>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <div
                  @click="modalconfirm"
                  v-ripple
                  class="addcartbtn Kanit myshadow"
                >
                  <p v-if="!saveloading">ยืนยันการประเมินราคา</p>
                  <div v-else>
                    <v-progress-circular
                      indeterminate
                      size="35"
                      color="white"
                    ></v-progress-circular>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </transition>
    </v-container>
    <v-dialog v-model="showConfirm" persistent width="550px">
      <v-card style="position: relative">
        <div
          @click.stop="showConfirm = false"
          style="position: absolute; right: 4px; top: 4px"
        >
          <v-icon style="font-size: 18px" color="red">mdi-close-thick</v-icon>
        </div>
        <v-card-text class="pa-5">
          <div class="Kanit">
            <div
              class="text-center mb-3"
              style="font-weight: bold; font-size: 18px"
            >
              ยืนยันราคา
            </div>
            <div>
              เพื่อป้องกันความผิดพลาดในส่วนของราคาสินค้าและค่าขนส่งกรุณายืนยันราคาก่อนส่งถึงลูกค้า
              ราคาที่ส่งถึงลูกค้าแล้วร้านค้าจะไม่สามารถกดยกเลิกการเสนอราคาได้
            </div>
            <div>
              <v-row>
                <v-col cols="12" class="pr-0">
                  <div>ราคาสินค้า: {{ sumprice }} บาท</div>
                  <div>
                    ค่าขนส่ง:
                    {{ formatedShippingprice ? formatedShippingprice : 0 }} บาท
                  </div>
                  <div style="color: red; font-size: 20px">
                    ราคารวม :
                    {{
                      (formatedShippingprice
                        ? parseFloat(formatedShippingprice)
                        : 0) + parseFloat(sumprice)
                    }}
                    บาท
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="text-right">*การเสนอราคาจะหมดอายุใน 30 วัน</div>
          </div>
          <div>
            <v-btn
              @click="confirmPrice"
              :loading="saveloading"
              class="Kanit"
              color="#0c4d9d"
              dark
              block
              >ยืนยัน</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import UploadFile from "@/components/UploadProfile";
import Loading from "@/components/Loading.vue";
export default {
  data() {
    return {
      showConfirm: false,
      transitionname: "slidedealer",
      loading: true,
      radios: "",
      step: 1,
      saveloading: false,
      storeshippingprice: "",
      shippingprice: 0,
      products: [],
      data2: "",
      additionalshippingprice: 0,
      remark: "",
    };
  },
  components: {
    Loading,
    UploadFile,
  },
  computed: {
    formatedShippingprice() {
      if (this.radios == "scgexpress") {
        return (
          parseFloat(this.shippingprice) +
          parseFloat(this.additionalshippingprice)
        );
      } else if (this.radios == "storeshipping") {
        return this.storeshippingprice;
      } else return 0;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    sumprice() {
      return this.products.reduce((a, b) => {
        return a + (b.price ? parseFloat(b.price) : 0) * parseFloat(b.quantity);
      }, 0);
    },
    hasGypsum() {
      return this.products.some((el) => {
        return el.main_category == "Gypsum";
      });
    },
  },
  async mounted() {
    await this.checkTransaction();
    await this.getOrder();
    this.calculateprice();
    this.loading = false;
  },
  methods: {
    async modalconfirm() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.showConfirm = true;
      }
    },
    checkTransaction() {
      var vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toadealertransaction",
            {
              params: {
                customerid: vm.query.customerid,
                order_number: vm.query.order_number,
              },
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              resolve();
            } else {
              vm.$swal
                .fire({
                  text: "มี Dealer รายอื่นเสนอราคาไปแล้ว",
                })
                .then(async (result) => {
                  if (this.query.apptype == "line") {
                    await this.$liff.closeWindow();
                  } else if (this.query.apptype == "facebook") {
                    this.$store.dispatch("messengerClose");
                  }
                  resolve();
                });
            }
          });
      });
    },
    afterEnter: () => {
      window.scrollTo(0, 0);
    },
    afterLeave: () => {
      Store.commit("setPageTransition", "default");
    },
    getOrder() {
      this.loading = true;
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toadealercalculatequotation",
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
              params: {
                customerid: this.query.customerid,
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
                order_number: this.query.order_number,
              },
            }
          )
          .then(async (response) => {
            // this.loading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              this.products = response.data.data;
              this.data2 = response.data.data2[0];
            }
            resolve();
          });
      });
    },
    back() {
      this.transitionname = "slidedealer-back";
      this.$nextTick(() => {
        this.step = 1;
      });
    },
    async calculateprice() {
      var vm = this;
      this.transitionname = "slidedealer";
      // this.saveloading = true;
      await this.checkTransaction();

      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        customerid: this.query.customerid,
        order_number: this.query.order_number,
      };
      axios
        .post(
          "https://communitybotbyzwizai.herokuapp.com/toacalculatecost",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          this.saveloading = false;
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200 && response.data.data) {
            this.shippingprice = parseFloat(response.data.data[0].cost).toFixed(
              2
            );
            // this.step = 2;
          } else {
            vm.$swal.fire({
              text: response.data.reason,
              icon: "error",
            });
          }
        });
    },
    async confirmPrice() {
      if (!this.saveloading) {
        var vm = this;
        this.saveloading = true;
        await this.checkTransaction();
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          customerid: this.query.customerid,
          cartlist: this.products, // response ที่ได้จาก api get ที่เพิ่ม price เข้ามา
          shippingcharge: this.formatedShippingprice, // ค่าจัดส่ง
          totalwithoutship: this.sumprice, // ราคารวามสินค้า
          shippingtype: this.radios,
          order_number: this.query.order_number,
          note: this.remark,
          total:
            parseFloat(this.sumprice) + parseFloat(this.formatedShippingprice), // ราคารวมสินค้า + ค่าจัดส่ง
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toadealercalculatequotation",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              await vm.$swal.fire({
                icon: "success",
                text: "กรุณารอการยืนยันจากลูกค้า",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "ไม่สำเร็จ",
              });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.smallpriceinput.v-text-field input {
  font-size: 12px;
}
.smallpriceinput .v-input__slot fieldset {
  height: 27px;
}
.smallpriceinput .v-input__slot div {
  height: 21px;
}
.radiosmallfont .v-label {
  font-size: 12px;
}
.compact-form.v-text-field input {
  font-size: 24px;
}
.compact-form .v-messages__message {
  font-size: 15px;
}
.compact-form.v-text-field label {
  font-size: 24px;
}
.compact-form {
  transform: scale(0.655);
  transform-origin: left;
}
$duration: 0.5s;
.transition {
  overflow: hidden;
}

table.quotationtable .borderbot {
  border-bottom: 1px solid #b9b9b9;
}
table.quotationtable td {
  text-align: center;
  border-right: 1px solid #b9b9b9;
}
table {
  margin-top: 40px;
}
</style>